import { DatePipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
  name: "localizeDate",
  pure: false,
})
export class LocalizeDatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {
  }

  transform(value: any, pattern: string = "mediumDate", timezone: string = "UTC" ): any {
    try {
      const locale: string = this.translateService.currentLang == "en" ? "" : "ar-EG-u-nu-latn";
      const datePipe: DatePipe = new DatePipe(locale);
      return datePipe.transform(value, pattern, timezone);
    } catch (error) {
      return value.toString()
      // value = value.replaceAll("/", "-");
      // let datePart = value.split(",")[0].trim(); // Extract the date part
      // datePart = datePart.toLocaleString();
      // // Split the input date string into day, month, and year parts
      // const [day, month, year] = datePart.split("-");
      // // Create a new Date object by providing year, month (0-indexed), and day
      // const dateObj = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
      // // Create an Intl.DateTimeFormat object with locale set to Arabic
      // const formatter = new Intl.DateTimeFormat("ar", { month: "long" });
      // // Get the month name in Arabic from the formatter
      // const monthName = formatter.format(dateObj);
      // // Construct the desired date format
      // const formattedDate = `${day} ${monthName}   ${year}`;
      // return formattedDate;
    }
  }

}
